import { singleton } from "tsyringe";
import ChoiceServiceClassToken from "common/resources/injectables/ChoiceServiceClassToken";

@singleton()
export default class ChoiceService implements ChoiceServiceClassToken {
	// TODO: Implement the methods
	public async exists(_id: string): Promise<boolean> {
		return true;
	}

	public async isChoiceBelongToQuestion(_id: string, _questionId: string): Promise<boolean> {
		return true;
	}
}
